import { FlexColumn, TextField } from '@elementary/common-ui/components';
import { InputLabel } from '@mui/material';
import CopyButton from 'shared/components/CopyButton';

type Props = {
  label: string;
  value: string;
};

const SensitiveInfoDisplay = ({ label, value }: Props) => (
  <FlexColumn>
    <InputLabel shrink>{label}</InputLabel>
    <TextField
      value={value}
      InputProps={{
        readOnly: true,
        endAdornment: <CopyButton textToCopy={value} />,
        sx: {
          '& .MuiInputBase-input': {
            cursor: 'default',
          },
          '& .MuiInputAdornment-root': {
            pointerEvents: 'auto',
          },
        },
      }}
    />
  </FlexColumn>
);

export default SensitiveInfoDisplay;
